/**
 * Utility functions for URL manipulation.
 *
 * Note: Angular Router in this app uses APP_BASE_HREF='/' (see app.module.ts),
 * so router URLs (state.url, router.url) and window.location.pathname already
 * reflect the canonical path the user sees. The production `<base href="/parta/">`
 * tag exists only so relative asset URLs (main.js, etc.) resolve under `/parta/`
 * behind the reverse proxy — it has no bearing on app routing.
 *
 * Consequently, redirect URIs must preserve the caller-supplied path verbatim:
 * adding or stripping `/parta/` here would break deep links that the user
 * typed/bookmarked without it, and would mangle URLs like `/parta` → `/parta/parta`.
 */

/**
 * Converts a path to a full absolute URL by prepending the current origin.
 * Used for OAuth redirect URIs and post-login URL restoration. The path is
 * preserved verbatim — only a leading slash is added if missing.
 */
export function routerUrlToAbsolute(routerUrl: string): string {
  return (
    window.location.origin +
    (routerUrl.startsWith('/') ? routerUrl : '/' + routerUrl)
  );
}

/**
 * Checks whether an absolute URL is same-origin as the current page.
 * Returns false for malformed URLs.
 */
export function isSameOriginUrl(url: string): boolean {
  try {
    return new URL(url).origin === window.location.origin;
  } catch {
    return false;
  }
}
